import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        meta: {
            title: '登录',
            icon: '登录'
        },
        component: () => import('@/views/my-login/index-home.vue')
    },
    {
        path: '/password-login',
        meta: {
            title: '登录',
            icon: '登录'
        },
        component: () => import('@/views/my-login/login.vue')
    },
    {
        path: '/',
        meta: {
            title: '网规地图',
            icon: '网规地图'
        },
        component: () => import('@/views/homePage/index'),
        children: [
            {
                meta: {
                    title: '网规地图',
                    icon: '网规地图'
                },
                path: '/workbench',
                component: () => import('@/views/workbench/index')
            },
            {
                meta: {
                    title: '网规地图',
                    icon: '网规地图'
                },
                path: '/newWorkbench',
                component: () => import('@/views/newWorkbench/index')
            },
            {
                meta: {
                    title: '市场容量测算',
                    icon: '市场容量测算'
                },
                path: '/capacityMeasurement',
                component: () => import('@/views/capacityMeasurement/index')
            }
        ]
    }
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
});

export default router;
